import Skeleton from "react-loading-skeleton";
import { useGetUserById } from "@repo/hooks/queries";
import type { RecordId } from "@repo/types/ui/tables";

export interface ViewUserProps {
  userId: RecordId;
}

const ViewUser = ({ userId }: ViewUserProps) => {
  const { data: user } = useGetUserById(userId);

  return (
    <div className={"p-4"}>
      User name: {user ? `${user.FirstName} ${user.LastName}` : <Skeleton />}
    </div>
  );
};

export { ViewUser };
